#import "@/apollo/fragments/MasterTemplate.gql"

mutation UpdateTemplate($zipUrl: String!, $masterTemplateId: ID!, $force: Boolean, $type: TemplateType) {
    updateMasterTemplate(
        temporaryBucketZipPath: $zipUrl
        masterTemplateId: $masterTemplateId
        force: $force
        type: $type
    ) {
        updatedMasterTemplate {
            _id
        }
        usedInCampaigns {
            _id
            name
        }
        producedAds {
            published
            unpublished
        }
        editableGroupConflicts {
            added
            removed
        }
        templateFamily {
            ...MasterTemplate
            parentId
            parentWidth
            parentHeight
        }
    }
}
